<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Kite Festival </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"
            alt="GHRSCF" />
    </div>
</section>
<section class="section section-sm kite-festival section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Kite <span> Festival </span></h2>
            <p>We learned that Kite flying is not just festival, it is a team sport.One person prepares <br>the kite to
                fly in the open sky.</p>
        </div>

        <div class="row text-justify">
            <div class="col-md-4">
                <div class="image-effect-2">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival.webp"
                        alt="GHRSCF" class="w-100">
                </div>
            </div>

            <div class="col-md-8">
                <div class="widget_title inner-title">
                    <h4>MAKAR SANKRANTI FUN HAPPENS IN RGI</h4>
                </div>

                <div class="fide-chess-text">
                    <p> Every January with the reason of Makar Sankranti fun happens in RGI. On the promising
                        Celebration
                        of Uttarayan, We organize “Kite-flying” celebration exceptionally. The sun moves towards North
                        direction from this day. If sun itself change a direction, so why not we take a little break
                        from
                        work and enjoy the festival and gather the energy to work more accurately and perfectly.</p>
                </div>
            </div>
            <div class="col-md-12 mt-3">
                <p>
                    Moreover, we learned that Kite flying is not just festival, it is a team sport. One person prepares
                    the kite to fly in the open sky. Another person keeps reveals the manja for the flier.
                    The co-ordination between the two people is very important. These things make kite flying a group
                    occasion. Exactly our all team members work with great co-ordination in office and complete
                    successful
                    projects in given time.
                </p>
                <p>Uttarayan is a festival of kites and manja but this manja is very dangerous for birds. So we decided
                    to
                    spread a message that we have to care about other creature of the earth. Not only birds but many
                    human also
                    hurt by this manja and they may lose their life.</p>
            </div>

        </div>
        <div class="row">
            <div class="col-md-8">
                <div class="widget_title inner-title">
                    <h4>Kite Festival 2026 </h4>
                </div>
            </div>
            <div class="col-md-4 text-end">
                <a href="https://drive.google.com/drive/folders/1NseEucpjtL6FXJwN74ujgWeIwjtv4NaP" target="_blank"
                    class="cmn-button"><span>
                        View More</span>
                </a>
            </div>
        </div>
        <div class="lightBox--gallery">
            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-8.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-8.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-8.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-2.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-2.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-2.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>

                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-3.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-3.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-3.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-4.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-4.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-4.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-1.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-1.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-1.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-6.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-6.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-6.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-7.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-7.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-7.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-5.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-5.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-5.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>

            </ul>
        </div>
        <div class="row mt-5">
            <div class="col-md-8">
                <div class="widget_title inner-title">
                    <h4>Kite Festival 2025 </h4>
                </div>
            </div>
            <!-- <div class="col-md-4 text-end">
                <a href="https://drive.google.com/drive/folders/1NhMJCxJFXrDi9PvB7Ku0iZgWmsHMxyyg?usp=drive_link "
                    target="_blank" class="cmn-button"><span>
                        View More</span>
                </a>
            </div> -->
        </div>
        <div class="lightBox--gallery">
            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-fest-26-1.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-1.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-1.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-2.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-2.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-2.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>

                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-3.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-3.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-3.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-4.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-4.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-4.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-8.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-8.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-8.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-6.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-6.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-6.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-7.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-7.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-7.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-9.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-9.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-9.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-10.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-10.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-10.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-11.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-11.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-11.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-5.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-5.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-5.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>

            </ul>
        </div>
        <div class="row mt-5">
            <div class="col-md-8">
                <div class="widget_title inner-title">
                    <h4>Kite Festival 2024 </h4>
                </div>
            </div>
            <div class="col-md-4 text-end">
                <a href="https://drive.google.com/drive/folders/1NhMJCxJFXrDi9PvB7Ku0iZgWmsHMxyyg?usp=drive_link "
                    target="_blank" class="cmn-button"><span>
                        View More</span>
                </a>
            </div>
        </div>
        <div class="lightBox--gallery">
            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-24-1.jpg"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-24-1.jpg">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-24-1.jpg"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-24-2.jpg"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-24-2.jpg">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-24-2.jpg"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-24-3.jpg"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-24-3.jpg">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-24-3.jpg"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-24-4.jpg"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-24-4.jpg">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-24-4.jpg"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-24-5.jpg"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-24-5.jpg">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-24-5.jpg"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-24-6.jpg"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-24-6.jpg">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-24-6.jpg"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>


            </ul>
        </div>
        <div class="row mt-5">
            <div class="col-md-8">
                <div class="widget_title inner-title">
                    <h4>Kite Festival 2023 </h4>
                </div>
            </div>

        </div>
        <div class="lightBox--gallery">
            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival.jpg"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival.jpg">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival.jpg"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival-1.jpg"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival-1.jpg">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival-1.jpg"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival-2.jpg"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival-2.jpg">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival-2.jpg"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival-3.jpg"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival-3.jpg">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival-3.jpg"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival-4.jpg"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival-4.jpg">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival-4.jpg"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival-5.jpg"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival-5.jpg">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival-5.jpg"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival-6.jpg"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival-6.jpg">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival-6.jpg"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival-7.jpg"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival-7.jpg">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-festival-7.jpg"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>

            </ul>
        </div>

    </div>
</section>
